let mouseclientX,
  mouseclientY,
  oldX,
  oldY,
  currentScreenPoint,
  currentSvgPoint,
  zoomRate = 1.2,
  isMove = !1,
  currentScale = 1,
  shoeROhide = !0,
  isScale = false

function move(e, svgElement) {
  if (((mouseclientX = e.clientX), (mouseclientY = e.clientY), isMove)) {
    let t = e.clientX - oldX,
      n = e.clientY - oldY,
      o = svgElement.getAttribute('viewBox').split(' ')
    ;(o[0] = parseFloat(o[0])),
      (o[1] = parseFloat(o[1])),
      (o[0] -= t / currentScale),
      (o[1] -= n / currentScale),
      svgElement.setAttribute('viewBox', o.join(' ')),
      (oldX = e.clientX),
      (oldY = e.clientY)
  }
  getScreenPointAndSvgPoint(e, svgElement),
    (e.cancelBubble = !0),
    e.stopPropagation(),
    (e.returnValue = !1),
    e.preventDefault()
}

function getScreenPointAndSvgPoint(e, svgElement) {
  currentScreenPoint = {
    x: e.pageX,
    y: e.pageY,
  }
  let t = svgElement.createSVGPoint()
  t.x = currentScreenPoint.x
  t.y = currentScreenPoint.y
  let n = svgElement.getScreenCTM()
  currentSvgPoint = t.matrixTransform(n.inverse())
}

function zoomOnMouseWheel(e, svgElement, iframeWidth, iframeHeight) {
  currentScreenPoint = {
    x: e.offsetX,
    y: e.offsetY,
  }
  if (isScale) {
    currentScreenPoint = {
      x: e.offsetX,
      y: e.offsetY - iframeHeight / 2.5,
    }
  }
  var t,
    n = svgElement.getAttribute('viewBox').split(' ')
  if (
    ((n[0] = parseFloat(n[0])),
    (n[1] = parseFloat(n[1])),
    (n[2] = parseFloat(n[2])),
    (n[3] = parseFloat(n[3])),
    (t = e.wheelDelta ? e.wheelDelta : -e.detail) > 0 && currentScale < 16)
  )
    (n[2] /= zoomRate), (n[3] /= zoomRate)
  else {
    if (!(t < 0 && currentScale > 0.5)) return !1
    ;(n[2] *= zoomRate), (n[3] *= zoomRate)
  }
  currentScale = iframeWidth / n[2]
  n[0] = currentSvgPoint.x - currentScreenPoint.x / currentScale
  n[1] = currentSvgPoint.y - currentScreenPoint.y / currentScale
  svgElement.setAttribute('viewBox', n.join(' '))
}

function clickDown(e, svgElement) {
  0 == e.button && (shoeROhide = !0),
    1 == e.button &&
      ((isMove = !0),
      (svgElement.style.cursor = 'move'),
      (oldX = e.clientX),
      (oldY = e.clientY),
      (e.cancelBubble = !0),
      e.stopPropagation(),
      (e.returnValue = !1),
      e.preventDefault())
}

function clickUp(e, svgElement) {
  ;(isMove = !1),
    'move' == svgElement.style.cursor && (svgElement.style.cursor = 'default'),
    (e.cancelBubble = !0),
    e.stopPropagation(),
    (e.returnValue = !1),
    e.preventDefault()
}
export function load(dom, state) {
  // 当前鼠标移动到的节点位置
  const svgIframe = $(`#${dom}`)[0]
  // iframe宽度
  const iframeWidth = svgIframe.offsetWidth
  // 文档显示区高度
  const iframeHeight = svgIframe.offsetHeight
  setTimeout(() => {
    // 初始化设置svg宽度为父级iframe宽度，高度为父级iframe高度
    $(`#${dom} svg`).attr('width', iframeWidth)
    $(`#${dom} svg`).attr('height', iframeHeight)
    if (state === 'big') {
      $(`#${dom} svg`).attr('viewBox', `-74 64 ${iframeWidth - 274} ${iframeHeight - 114}`)
    } else {
      $(`#${dom} svg`).attr('viewBox', `0 0 ${iframeWidth + 384} ${iframeHeight + 265}`)
    }
    // svg滚动事件
    $(`#${dom} svg`)[0].onmousewheel = (e) => {
      zoomOnMouseWheel(e, $(`#${dom} svg`)[0], iframeWidth, iframeHeight)
    }
    // 鼠标点击按下事件
    $(`#${dom} svg`)[0].onmousedown = (e) => {
      clickDown(e, $(`#${dom} svg`)[0])
    }
    // 鼠标按下抬起事件
    $(`#${dom} svg`)[0].onmouseup = (e) => {
      clickUp(e, $(`#${dom} svg`)[0])
    }
    // 鼠标移动
    $(`#${dom} svg`)[0].onmousemove = (e) => {
      move(e, $(`#${dom} svg`)[0])
    }
    // 获取初始化viewBox的坐标
    const initViewBox = $(`#${dom} svg`).attr('viewBox')
    // 双击还原初始化大小及位置
    $(`#${dom} svg`)[0].ondblclick = (e) => {
      isScale = false
      $(`#${dom} svg`).attr('viewBox', initViewBox)
    }
    // 获取所有a标签
    const tagA = $(`#${dom} svg a`)
    for (let i = 0; i < tagA.length; i += 1) {
      tagA[i].onclick = (e) => {
        isScale = true
        $(`#${dom} svg`).attr('viewBox', initViewBox)
        const viewBox = []
        let ctm
        if (tagA[i].innerHTML.includes('<text')) {
          ctm = tagA[i].childNodes[0].getCTM()
        } else {
          ctm = tagA[i].parentNode.getCTM()
        }
        viewBox[0] = ctm.e - iframeWidth / 12
        viewBox[1] = ctm.f - iframeWidth / 230
        viewBox[2] = iframeWidth / 5
        viewBox[3] = iframeHeight / 40
        $(`#${dom} svg`).attr('viewBox', viewBox.join(' '))
      }
    }
    window.addEventListener('message', () => {
      _.forEach(tagA, (item) => {
        if (item.innerHTML.includes('<text')) {
          // 复合测点
          let text = ''
          for (let j = 0; j < item.childNodes.length; j += 1) {
            if (item.childNodes[j].nodeType === 1) {
              text = `${text}${item.childNodes[j].innerHTML}`
            }
          }
          if (text === e.data) {
            item.onclick()
          }
        } else if (item.innerHTML === '10') {
          item.onclick()
        }
      })
    })
  }, 1200)
}
